// Settings — bucket page that groups general Settings / System / Senders
// as sub-tabs. Renders the existing standalone page components unchanged.
// Tab state in ?tab=... so deep links from the old top-level routes
// (/system, /senders) survive via redirects.

import { useSearchParams } from 'react-router-dom';
import { Settings } from './Settings';
import { System } from './System';
import { Senders } from './Senders';

type TabId = 'general' | 'system' | 'senders';
const VALID: TabId[] = ['general', 'system', 'senders'];
const TABS: Array<{ id: TabId; label: string }> = [
  { id: 'general', label: 'Settings' },
  { id: 'system', label: 'System' },
  { id: 'senders', label: 'Senders' },
];

export function SettingsBucket() {
  const [params, setParams] = useSearchParams();
  const raw = params.get('tab') as TabId | null;
  const tab: TabId = raw && VALID.includes(raw) ? raw : 'general';

  const setTab = (id: TabId) => {
    params.set('tab', id);
    setParams(params, { replace: true });
  };

  return (
    <div className="bucket">
      <nav className="bucket__tabs" aria-label="Settings views">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`bucket__tab ${tab === t.id ? 'bucket__tab--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>
      <div className="bucket__body">
        {tab === 'general' && <Settings />}
        {tab === 'system' && <System />}
        {tab === 'senders' && <Senders />}
      </div>
    </div>
  );
}
